// Monthly / yearly toggle on /pricing. Both prices are server-rendered from
// src/_data/pricing.yml; this only swaps which one is visible.
function initPricingToggle(root) {
  const buttons = root.querySelectorAll("[data-cycle]")
  const priceEls = document.querySelectorAll("[data-price-monthly]")
  const periodEls = document.querySelectorAll("[data-period-monthly]")

  function setCycle(cycle) {
    buttons.forEach((btn) => {
      const active = btn.dataset.cycle === cycle
      btn.setAttribute("aria-pressed", String(active))
    })
    priceEls.forEach((el) => {
      el.textContent = cycle === "monthly" ? el.dataset.priceMonthly : el.dataset.priceYearly
    })
    periodEls.forEach((el) => {
      el.textContent = cycle === "monthly" ? el.dataset.periodMonthly : el.dataset.periodYearly
    })
    root.dataset.activeCycle = cycle
  }

  buttons.forEach((btn) => btn.addEventListener("click", () => setCycle(btn.dataset.cycle)))
  setCycle("monthly")
}

document.querySelectorAll("[data-pricing-toggle]").forEach(initPricingToggle)
